var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectoryImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    className: "header-icon m-2",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n        .cls-1 {\n            fill: #fff;\n            stroke-width: 0px;\n        }\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M169,186.5H54c-4.8,0-8.7-3.9-8.7-8.7V22.2c0-4.8,3.9-8.7,8.7-8.7h115c4.8,0,8.7,3.9,8.7,8.7v155.6c0,4.8-3.9,8.7-8.7,8.7ZM54,19.5c-1.5,0-2.7,1.2-2.7,2.7v155.6c0,1.5,1.2,2.7,2.7,2.7h115c1.5,0,2.7-1.2,2.7-2.7V22.2c0-1.5-1.2-2.7-2.7-2.7H54Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.3,56.6h-13.3c-3.4,0-6.6-1.3-9-3.7-2.4-2.4-3.7-5.6-3.7-9s1.3-6.6,3.7-9c2.4-2.4,5.6-3.7,9-3.7h26.5c3.4,0,6.6,1.3,9,3.7,2.4,2.4,3.7,5.6,3.7,9s-1.3,3-3,3-3-1.3-3-3-.7-3.5-2-4.7c-1.3-1.3-3-2-4.7-2h-26.5c-1.8,0-3.5.7-4.7,2-1.3,1.3-2,3-2,4.7s.7,3.5,2,4.7c1.3,1.3,3,2,4.7,2h13.3c1.7,0,3,1.3,3,3s-1.3,3-3,3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.3,95.1h-13.3c-3.4,0-6.6-1.3-9-3.7-2.4-2.4-3.7-5.6-3.7-9s1.3-6.6,3.7-9c2.4-2.4,5.6-3.7,9-3.7h26.5c3.4,0,6.6,1.3,9,3.7,2.4,2.4,3.7,5.6,3.7,9s-1.3,3-3,3-3-1.3-3-3-.7-3.5-2-4.7c-1.3-1.3-3-2-4.7-2h-26.5c-1.8,0-3.5.7-4.7,2-1.3,1.3-2,3-2,4.7s.7,3.5,2,4.7c1.3,1.3,3,2,4.7,2h13.3c1.7,0,3,1.3,3,3s-1.3,3-3,3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.3,133.6h-13.3c-3.4,0-6.6-1.3-9-3.7-2.4-2.4-3.7-5.6-3.7-9s1.3-6.6,3.7-9c2.4-2.4,5.6-3.7,9-3.7h26.5c3.4,0,6.6,1.3,9,3.7,2.4,2.4,3.7,5.6,3.7,9s-1.3,3-3,3-3-1.3-3-3-.7-3.5-2-4.7c-1.3-1.3-3-2-4.7-2h-26.5c-1.8,0-3.5.7-4.7,2-1.3,1.3-2,3-2,4.7s.7,3.5,2,4.7c1.3,1.3,3,2,4.7,2h13.3c1.7,0,3,1.3,3,3s-1.3,3-3,3Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.3,172.1h-13.3c-3.4,0-6.6-1.3-9-3.7-2.4-2.4-3.7-5.6-3.7-9s1.3-6.6,3.7-9c2.4-2.4,5.6-3.7,9-3.7h26.5c3.4,0,6.6,1.3,9,3.7,2.4,2.4,3.7,5.6,3.7,9s-1.3,3-3,3-3-1.3-3-3-.7-3.5-2-4.7c-1.3-1.3-3-2-4.7-2h-26.5c-1.8,0-3.5.7-4.7,2-1.3,1.3-2,3-2,4.7s.7,3.5,2,4.7c1.3,1.3,3,2,4.7,2h13.3c1.7,0,3,1.3,3,3s-1.3,3-3,3Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M152,70.7h-62.6c-1.7,0-3-1.3-3-3s1.3-3,3-3h62.6c1.7,0,3,1.3,3,3s-1.3,3-3,3Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M152,90.8h-62.6c-1.7,0-3-1.3-3-3s1.3-3,3-3h62.6c1.7,0,3,1.3,3,3s-1.3,3-3,3Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M152,110.2h-62.6c-1.7,0-3-1.3-3-3s1.3-3,3-3h62.6c1.7,0,3,1.3,3,3s-1.3,3-3,3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectoryImg);
export default __webpack_public_path__ + "static/media/directoryImg.9d3708e431a032dd179ba5338c0303d3.svg";
export { ForwardRef as ReactComponent };